import React, { Component } from 'react';
import {FormattedMessage} from 'react-intl';
import ReportesGrid from './ReportesGrid.jsx';
import { Route, Switch } from 'react-router-dom';

class Reportes extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
						<h3 className="content-header-title"><FormattedMessage id="Reportes.Administracion_de_Reportes" defaultMessage="Administración de Reportes"/></h3>
					</div>
				</div>
				<div className="content-body">								
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={ReportesGrid} />
					</Switch>										
				</div>
			</div>
		);
	}
}

export default Reportes;